<template>
  <div class="recommand" style="padding: 30px 0">
    <el-row class="info">
      <el-col class="info-item">
        <img class="avatar" :src="source.photo_url || default_avatar">
        <a-button class="view_btn" v-if="isResume" type="link" icon="eye" size="large" @click="previewResume">查看附件简历</a-button>
      </el-col>
      <el-col class="name info-item">
        {{source.name}}
      </el-col>
      <el-col class="tags info-item">
        <i class="icon el-icon-phone-outline"></i>  <span>{{source.mobile}}</span>
        <el-divider direction="vertical"></el-divider>
        <i class="icon el-icon-star-off"></i> {{ source.email }}
      </el-col>
      <el-col class="info-item">
        {{source.age}}岁 {{gender_id[source.gender_id]}} {{source.education_name}} {{source.school_graduated}} {{source.title}}
      </el-col>
      <el-col>
        <el-divider></el-divider>
      </el-col>
      <el-col class="info-item">
        自我描述： {{source.description}}
      </el-col>
      <el-col class="info-item">
        <!-- <span style="margin-right:10px;">个人标签</span>
        <el-tag style="margin-right:10px;" size="mini">认真负责</el-tag>
        <el-tag style="margin-right:10px;" size="mini">善于沟通</el-tag>
        <el-tag style="margin-right:10px;" size="mini">团队协作</el-tag>
        <el-tag style="margin-right:10px;" size="mini">文笔出众</el-tag> -->
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-bottom:15px">
      <el-col>
        <span class="left-line"></span>
        <b>工作经历</b>
      </el-col>
    </el-row>
    <div class="experience">
      <el-timeline>
        <el-timeline-item :timestamp="item.date" placement="top" v-for="(item, index) in source.work_experiences" :key="index">
          <el-card>
            <h4>{{ item.company_name }}</h4>
            <h4>{{ item.job }}</h4>
            <p>{{ item.duty }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
    <el-row type="flex" justify="space-between" style="margin-bottom:15px">
      <el-col>
        <span class="left-line"></span>
        <b>项目经历</b>
      </el-col>
    </el-row>
    <div class="experience">
      <el-timeline>
        <el-timeline-item :timestamp="item.date" placement="top" v-for="(item, index) in source.project_experiences" :key="index">
          <el-card>
            <h4>{{ item.name }}</h4>
            <p style="color:#999;font-size:13px;">{{ item.time_start + ' - ' + (item.time_end || '至今') }}</p>
            <p>{{ item.description }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  name: "Candidate",
  props: {
    source: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isResume:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      default_avatar: require("@/app/admin/order/images/default_avatar.png"),
      gender_id:['无要求','男','女'],
      education_id:['','无要求','高中及以上','大专及以上','本科及以上','硕士及以上','博士及以上'],
      experience_id:['不限','1年以下','1-3年','3-5年','5-10年','10-15年','15年以上'],
      // experience: [
      //   { companyName: '浪淘金(北京)科技有限责任公司', position: 'Java工程师/项目经理',  content: 'Lorem ipsum dolor sit amet, consectetur adi', date: '2015-03--2015-08' }, 
      //   { companyName: '浪淘金(北京)科技有限责任公司', position: 'Java工程师/项目经理',  content: 'Lorem ipsum dolor sit amet, consectetur adi', date: '2015-03--2015-08' }, 
      //   { companyName: '浪淘金(北京)科技有限责任公司', position: 'Java工程师/项目经理',  content: 'Lorem ipsum dolor sit amet, consectetur adi', date: '2015-03--2015-08' }, 
      // ],
      project: [
        { name: 'xxxx项目', company: '浪淘金(北京)科技有限责任公司', desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ', date: '2015-03--2015-08'},
        { name: 'xxxx项目', company: '浪淘金(北京)科技有限责任公司', desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. ', date: '2015-03--2015-08'},
      ]
    }
  },
  methods: {
    previewResume() {
       this.$emit("view");
    }
  }
};
</script>
<style lang="scss" scoped>
.recommand {
  font-size: 14px;
  .info {
    padding-left: 20px;
    margin-bottom: 30PX;
  }
  .info-item {
    margin: 10px 0;
    position: relative;
    .view_btn{
      position: absolute;
      right: 0;
      top: 2px;
    }
  }
  .avatar {
    width: 46px;
    height: 46px;
  }
  .experience {
    line-height: 26px;
  }
}
</style>
